import React, { useState } from 'react'
import { Button } from "@heroui/react"
import SectionTitle from '../components/common/SectionTitle'
import NewsCard from '../components/common/NewsCard'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { Helmet } from 'react-helmet'
import VideoModal from '../components/common/VideoModal'

const blogData = [{
    id: '1',
    title: 'Oxford College Gampaha: A Beacon of Excellence in Education',
    category: 'Education',
    date: '17 Feb 2025',
    img: 'https://images.pexels.com/photos/2982449/pexels-photo-2982449.jpeg'
}, {
    id: '2',
    title: 'The Oxford College Gampaha Experience: A Day in the Life of a Student',
    category: 'Diversity',
    date: '18 Feb 2025',
    img: 'assets/images/events/preschool-activities/img5.webp'
}, {
    id: '3',
    title: 'Preparing for the Future: Career Guidance and Higher Education Support at Oxford College Gampaha ',
    category: 'Higher Education',
    date: '19 Feb 2025',
    img: 'https://images.pexels.com/photos/6334763/pexels-photo-6334763.jpeg'
},
]

function Home() {
    const [showModal, setShowModal] = useState(false);
    const [expandedTestimonials, setExpandedTestimonials] = useState({});

    const testimonials = [
        {
            "name": "Ganidu Abeywardene",
            "img": './assets/images/testimonials/img1.webp',
            "location": "Colombo",
            "description": "Dear sir, the results I have today is truly a reflection of your unflattering efforts and guidance. It’s been almost a decade since I became a student of you and from the very first day I met you, you not only provided education but, most importantly shaped our lives and paved the path to what we are now. Sir, you were not only our teacher but also our dearest friend in this journey together. So, please accept my sincere gratitude and thank you sir for all you do - and for the kind and thoughtful way you do it all!"
        },
        {
            "name": "Yasasi Mindara",
            "img": './assets/images/testimonials/img2.webp',
            "location": "Galle",
            "description": "Dear sir, This would never be possible if it weren't for you sir. For ten years you've shaped me to become what I am today and I'm forever grateful. You were able to manage every single task and cover every weak points we had. You worked together with us and drove us towards our goals and cleared our paths. Thank you so much for all that sir! I'm forever grateful!"
        },
        {
            "name": "Vethmi",
            "img": './assets/images/testimonials/img3.webp',
            "location": "Kandy",
            "description": "Dear Sumedha sir, I wouldn't ever have gotten an A pass for the FCE examination if it weren't for your help. I wholeheartedly thank you for dragging me out of my comfort zone and showing me the right path. I wish you the very best in every step of your life"
        },
        {
            "name": "M N Fathima Fazila",
            "img": './assets/images/testimonials/img4.webp',
            "location": "Negombo",
            "description": "Dear sir, Thank you very much for your guidance and support given to us sir Also the kindness and encouragement you showed toward us made us grow and achieve good results in our exam."
        },
        {
            "name": "Sanaya",
            "img": './assets/images/testimonials/img5.webp',
            "location": "Matara",
            "description": "Dear Sir, my heartiest gratitude to you sir❤ You are the hero behind the stage 💐 If it weren't for you, none of us would be where we are🤍 May lord buddha bless you with a happy and bright future!❤ "
        }
    ];

    const toggleReadMore = (index) => {
        setExpandedTestimonials((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const getClippedDescription = (description, index) => {
        const words = description.split(' ');
        if (words.length > 30) {
            return (
                <>
                    {words.slice(0, 30).join(' ')}...
                    <span
                        className="text-blue-600 font-semibold ms-2 cursor-pointer ml-1"
                        onClick={() => toggleReadMore(index)}
                    >
                        Read More
                    </span>
                </>
            );
        }
        return description;
    };

    return (<>
        <Helmet>
            <title>Welcome to Oxford College</title>
            <meta name="description" content="Welcome to Oxford College. Discover a world of educational opportunities." />
            <meta name="keywords" content="Home, Oxford College, Education, Excellence" />
            <meta name="author" content="Oxford College - Gampaha" />
            <meta property="og:title" content="Home - Oxford College - Gampaha" />
            <meta property="og:description" content="Explore educational opportunities at Oxford College and join our community." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://oxfordcollege.lk/" />
            <meta property="og:image" content="https://www.facebook.com/photo/?fbid=127196623392555&set=a.127196626725888" />
        </Helmet>

        <section className='relative min-h-[40rem] md:min-h-[50rem] lg:min-h-[60rem]'>
            <img src='./assets/images/hero-image.webp' alt='hero' className='w-auto h-[40rem] md:w-full md:h-[50rem] lg:h-full object-cover max-h-[60rem]' />
            <div
                className='absolute inset-0 md:p-4 lg:ps-16 bg-gradient-to-r from-black/70 via-60% via-transparent to-transparent bg-opacity-20 flex items-center justify-center md:justify-start'>
                <div className='text-white text-center md:text-left drop-shadow-lg p-4'>
                    <h1 className='md:text-title text-6xl font-bebas text-center md:text-start leading-tight'>Empowering
                        the<br />Minds of Tomorrow</h1>
                    <p className='px-2 text-sm md:text-body leading-relaxed text-center md:text-start'>We are
                        dedicated to inspiring a love of learning and empowering our students to
                        become <br /> compassionate, knowledgeable global citizens.</p>
                    <Button className='mt-5 bg-primary-blue text-white' radius='sm'
                        onPress={() => {
                            window.location.href = '/about'
                        }
                        }
                    >Learn More</Button>
                </div>
            </div>
        </section>
        <section className='container mx-auto pt-16 grid md:grid-cols-2 lg:order-1 px-4 gap-10 items-center'>
            <VideoModal
                show={showModal}
                onClose={() => setShowModal(false)}
                videoId="L2cv2HdF4Uc"
            />
            <div className='order-2 col-span-2 lg:col-span-1 lg:order-1 h-full relative rounded-2xl overflow-clip'>
                <img src='./assets/images/homepg_section1.webp' alt='hero' className='h-full object-cover' />
                <div className='absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center'>
                    <div class="relative w-20 h-20 flex items-center justify-center bg-secondary-blue rounded-full cursor-pointer"
                        onClick={() => setShowModal(true)}
                    >
                        <div class="relative z-10">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-6 h-6 text-white"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path d="M8 5v14l11-7z" />
                            </svg>
                        </div>
                        <div
                            class="absolute inset-0 before:absolute before:inset-0 before:rounded-full before:bg-secondary-50 before:opacity-50 after:absolute after:inset-0 after:rounded-full after:border-[8px] after:border-secondary-blue"></div>
                    </div>

                </div>
            </div>
            <div className='order-1 col-span-2 lg:col-span-1 lg:order-2'>
                <SectionTitle titleText='About Oxford College' subtitle={false} textAlignment={"start"} />
                <p>
                    Located in Gampaha, Oxford College has been a cornerstone of educational excellence for over 15
                    years. Our institution is dedicated to inspiring a lifelong passion for learning and empowering
                    students to achieve their full potential. We specialize in providing top-quality English
                    language education, focusing on Cambridge and General English courses for students aged 4 to 18.
                    <br />
                    <br />
                    At Oxford College, we emphasize a balanced approach to learning that nurtures not only academic
                    success but also critical thinking, creativity, and global awareness. As a Cambridge Exam
                    Preparation Centre, we equip students with internationally recognized qualifications, setting
                    them on a path to become confident communicators and responsible global citizens. Our supportive
                    learning environment encourages students to excel, build self-confidence, and embrace a diverse,
                    interconnected world.
                    <br />
                    <br />
                    With a commitment to fostering both personal growth and academic achievements, Oxford College
                    stands as a beacon of opportunity and innovation, dedicated to shaping the leaders of tomorrow.
                </p>
            </div>
        </section>

        <section>
            <div className='container mx-auto pt-16'>
                <div className='grid grid-cols-1 md:grid-cols-2 gap-10'>

                    <div className='flex items-center justify-center'>
                        <img src='./assets/images/cambridgeLogo.webp' alt='hero' className='object-cover w-full' />
                    </div>

                    <div
                        className='flex items-center justify-center flex-col px-4'
                    >
                        <img src='./assets/images/homepg_section2.webp' alt='hero'
                            className='object-cover w-full rounded-2xl max-h-[19rem]' />
                    </div>

                </div>
            </div>
        </section>

        <section className='px-4 container mx-auto pt-16'>
            <SectionTitle titleText='Our Programs' subtitle={true} textAlignment={"center"}
                subtitleText={"We offer a diverse range of programs designed to equip you with the knowledge and skills needed for a successful future"} />
            <div className='lg:grid-cols-3 md:grid-cols-2 grid gap-4 mt-8'>

                <div className='bg-light-gray rounded-2xl p-4 text-end'>
                    <div className='flex items-start gap-3'>
                        <img src='./assets/icons/gradHat.svg' alt='hero'
                            className='object-cover rounded-2xl h-[6.5rem] md:h-[4.5rem] aspect-square' />
                        <div className='text-start'>
                            <h3 className='text-lg font-bold'>Oxford English Qualification</h3>
                            <p className='text-sm'>The Oxford English Qualification is a globally recognized
                                certification that assesses practical English language skills for academic,
                                professional, or personal use.</p>
                        </div>
                    </div>
                    <Button className='mt-5 bg-primary-blue text-white' radius='sm'
                        onPress={() => {
                            window.location.href = '/programs-and-courses?section=englishQualification'
                        }}
                    >Browse Programs</Button>
                </div>
                <div className='bg-light-gray rounded-2xl p-4 text-end'>
                    <div className='flex items-start gap-3'>
                        <img src='./assets/icons/gradHat.svg' alt='hero'
                            className='object-cover rounded-2xl h-[6.5rem] md:h-[4.5rem] aspect-square' />
                        <div className='text-start'>
                            <h3 className='text-lg font-bold'>Oxford College</h3>
                            <p className='text-sm'>Oxford College is a prestigious institution offering a wide range of
                                academic and professional programs, known for its high-quality education and commitment
                                to student success.</p>
                        </div>
                    </div>
                    <Button className='mt-5 bg-primary-blue text-white' radius='sm'
                        onPress={() => {
                            window.location.href = '/programs-and-courses?section=oxfordCollege'
                        }}
                    >Browse Programs</Button>
                </div>
                <div className='bg-light-gray rounded-2xl p-4 text-end'>
                    <div className='flex items-start gap-3'>
                        <img src='./assets/icons/gradHat.svg' alt='hero'
                            className='object-cover rounded-2xl h-[6.5rem] md:h-[4.5rem] aspect-square' />
                        <div className='text-start'>
                            <h3 className='text-lg font-bold'>International Pre School</h3>
                            <p className='text-sm'>Cambridge International Preschool provides a nurturing and engaging
                                environment, fostering early learning through a globally recognized curriculum designed
                                to build strong foundations for young learners.</p>
                        </div>
                    </div>
                    <Button className='mt-5 bg-primary-blue text-white' radius='sm' onPress={() => {
                        window.location.href = '/programs-and-courses?section=preSchool'
                    }}>Browse Programs</Button>
                </div>
            </div>
        </section>
        <section className="relative mt-16 text-white min-h-[24rem] md:min-h-[40rem] lg:min-h-[50rem]">
            {/* Background Image Container */}
            <div className="absolute inset-0 w-full h-full">
                <img
                    src="./assets/images/homepg_section3.webp"
                    alt="hero"
                    className="w-full h-full object-cover"
                />
                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-black/10" />
            </div>

            {/* Content Container */}
            <div
                className="relative z-10 flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-10 p-4 md:p-8 lg:p-16 min-h-[24rem] md:min-h-[40rem] lg:min-h-[50rem]">
                {/* Left Content Box */}
                <div className="w-full lg:w-2/3 lg:max-w-2xl bg-white rounded-2xl p-4 sm:p-6 lg:p-10">
                    <p className="font-semibold text-black text-sm md:text-base">
                        At Oxford College, we are committed to providing students with the tools and guidance they
                        need to achieve their goals. Our approach focuses on nurturing each student's unique
                        potential and fostering a lifelong love of learning.
                    </p>

                    <p className="text-black text-justify text-sm md:text-base mt-4">
                        Oxford College's programs are thoughtfully designed to support students at every stage of
                        their educational journey. From foundational learning in our pre-school programs to
                        specialized English language courses, we provide an environment where students can thrive.
                        <br className="hidden sm:block" />
                        With a focus on excellence, empathy, and ethical growth, our curriculum balances
                        intellectual, emotional, and social development. We believe in education that prepares
                        students not only for exams but also for life.
                    </p>

                    {/* Features Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 mt-6 lg:mt-8">
                        {/* Primary Schooling */}
                        <div className="text-start text-black">
                            <img
                                src="./assets/icons/book.svg"
                                alt="Primary Schooling"
                                className="w-8 h-8 lg:w-10 lg:h-10 my-2"
                            />
                            <span className="text-sm font-semibold my-1 block">Primary Schooling</span>
                            <p className="text-xs lg:text-sm font-light">A robust foundation in primary education
                                that builds essential academic skills.</p>
                        </div>

                        {/* Secondary Schooling */}
                        <div className="text-black text-start">
                            <img
                                src="./assets/icons/bookmark.svg"
                                alt="Secondary Schooling"
                                className="w-8 h-8 lg:w-10 lg:h-10 my-2"
                            />
                            <span className="text-sm font-semibold my-1 block">Secondary Schooling</span>
                            <p className="text-xs lg:text-sm font-light">Comprehensive secondary education that
                                fosters intellectual and personal growth.</p>
                        </div>

                        {/* National Curriculum */}
                        <div className="text-start text-black">
                            <img
                                src="./assets/icons/badge.svg"
                                alt="National Curriculum"
                                className="w-8 h-8 lg:w-10 lg:h-10 my-2"
                            />
                            <span className="text-sm font-semibold my-1 block">National Curriculum</span>
                            <p className="text-xs lg:text-sm font-light">Our official government curriculum for O/L
                                and A/L students, taught in English for global readiness.</p>
                        </div>

                        {/* International Program */}
                        <div className="text-start text-black">
                            <img
                                src="./assets/icons/trophy.svg"
                                alt="International Program"
                                className="w-8 h-8 lg:w-10 lg:h-10 my-2"
                            />
                            <span className="text-sm font-semibold my-1 block">International Program</span>
                            <p className="text-xs lg:text-sm font-light">Internationally recognized O/L and A/L
                                courses designed for students aiming for academic achievement beyond borders.</p>
                        </div>
                    </div>
                </div>

                {/* Right Content */}
                <div
                    className="w-full lg:w-1/3 lg:max-w-2xl text-end font-playFair text-base sm:text-lg lg:text-2xl leading-snug px-4 md:px-0">
                    Oxford College is dedicated to fostering an inclusive and diverse learning environment that
                    empowers students to become responsible, engaged, and knowledgeable global citizens.
                </div>
            </div>
        </section>

        <section className='container mx-auto pt-16'>
            <SectionTitle titleText='News And Updates' subtitle={true} textAlignment={"center"}
                subtitleText={"Stay Informed with the Latest Announcements and Insights"} />
            <div className='gap-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-10 p-4'>
                {/* <NewsCard />
                <NewsCard />
                <NewsCard /> */}

                {blogData.map((blog, index) => (
                    <NewsCard
                        key={index}
                        img={blog.img}
                        date={blog.date}
                        title={blog.title}
                        id={blog.id}
                    />
                ))}
            </div>
        </section>

        <section className='mx-auto mt-16 py-16 relative w-full grid grid-cols-1 lg:grid-cols-2'>
            <div className='relative bg-primary-blue hidden md:block'>
                <img src='./assets/images/homepg_section4.webp' alt='hero'
                    className='absolute object-contain h-full w-auto lg:scale-90 xl:scale-125 xl:left-36' />
            </div>
            <div className='bg-primary-blue text-white p-4 text-start gap-10'>
                <div className='py-10 px-5'>
                    <span>Admission</span>
                    <h2 className='text-6xl py-2 font-bebas'>How to Enroll</h2>
                    <div className='grid grid-cols-1 xl:grid-cols-2 gap-5'>
                        <div className='w-fit flex items-center gap-4 mt-4'>
                            <div
                                className='p-2 size-6 flex items-center justify-center rounded-full text-primary-blue bg-secondary-blue'>1
                            </div>
                            <div>
                                <h3 className='text-lg font-bold'>Inquiry</h3>
                                <p className='text-sm text-secondary-blue'>Begin your journey by filling out our Inquiry Form.</p>
                            </div>
                        </div>
                        <div className='w-fit flex items-center gap-4 mt-4'>
                            <div
                                className='p-2 size-6 flex items-center justify-center rounded-full text-primary-blue bg-secondary-blue'>2
                            </div>
                            <div>
                                <h3 className='text-lg font-bold'>Application Submission</h3>
                                <p className='text-sm text-secondary-blue'>Start your enrollment journey by completing and submitting the application form, available online or in person.</p>
                            </div>
                        </div>
                        <div className='w-fit flex items-center gap-4 mt-4'>
                            <div
                                className='p-2 size-6 flex items-center justify-center rounded-full text-primary-blue bg-secondary-blue'>3
                            </div>
                            <div>
                                <h3 className='text-lg font-bold'>Placement Test</h3>
                                <p className='text-sm text-secondary-blue'>To determine the course that best matches your skills, we administer a placement test.</p>
                            </div>
                        </div>
                        <div className='w-fit flex items-center gap-4 mt-4'>
                            <div
                                className='p-2 size-6 flex items-center justify-center rounded-full text-primary-blue bg-secondary-blue'>4
                            </div>
                            <div>
                                <h3 className='text-lg font-bold'>Course Placement</h3>
                                <p className='text-sm text-secondary-blue'>Based on your placement test results, we will enroll you in a course tailored to your current proficiency level</p>
                            </div>
                        </div>
                        <div className='w-fit flex items-center gap-4 mt-4'>
                            <div
                                className='p-2 size-6 flex items-center justify-center rounded-full text-primary-blue bg-secondary-blue'>5
                            </div>
                            <div>
                                <h3 className='text-lg font-bold'>Confirmation & Registration</h3>
                                <p className='text-sm text-secondary-blue'>Once your placement is finalized, parents will receive detailed course information.</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section className="container mx-auto pt-16">
            <SectionTitle
                titleText="Testimonials"
                subtitle={true}
                textAlignment={"center"}
                subtitleText={"Real Experiences, Real Success"}
            />
            <div className="relative mt-12 select-none">
                <div
                    className="-mx-2 hidden lg:flex absolute top-1/2 left-5 transform -translate-y-1/2 z-10 cursor-pointer bg-black aspect-square w-10 items-center justify-center text-white p-1 rounded-full"
                    id="customPrev"
                >
                    <FaChevronLeft />
                </div>
                <div
                    className="-mx-2 hidden lg:flex absolute top-1/2 right-5 transform -translate-y-1/2 z-10 cursor-pointer bg-black aspect-square w-10 items-center justify-center text-white p-2 rounded-full"
                    id="customNext"
                >
                    <FaChevronRight />
                </div>

                <div className="relative px-10 mt-12">
                    <Swiper
                        className="mt-12"
                        modules={[Navigation]}
                        navigation={{
                            prevEl: '#customPrev',
                            nextEl: '#customNext',
                        }}
                        autoplay={{ delay: 1000 }}
                        loop={true}
                        spaceBetween={50}
                        slidesPerView={1}
                        breakpoints={{
                            640: {
                                slidesPerView: 1,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            1024: {
                                slidesPerView: 3,
                                spaceBetween: 50,
                            },
                            1280: {
                                slidesPerView: 4,
                                spaceBetween: 60,
                            },
                        }}
                    >
                        {testimonials.map((testimonial, index) => (
                            <SwiperSlide key={index}>
                                <div className="bg-light-gray p-4 rounded-2xl">
                                    <div className="w-20 h-20 bg-secondary-blue rounded-full flex items-center justify-center mx-auto my-5">
                                        <img
                                            src={testimonial.img}
                                            alt="hero"
                                            className="object-cover rounded-full"
                                        />
                                    </div>
                                    <h3 className="text-lg font-semibold text-center">
                                        {testimonial.name}
                                    </h3>
                                    <p className="text-sm text-center p-6">
                                        {expandedTestimonials[index]
                                            ? testimonial.description
                                            : getClippedDescription(testimonial.description, index)}
                                    </p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>

    </>)
}

export default Home